import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

const DRAWER_WIDTH_OPEN = 280;
const DRAWER_WIDTH_CLOSED = 72;
const RAIL_WIDTH = 26;
const RAIL_HEIGHT = 26;
const DEFAULT_TOP_OFFSET = 64;

const RAIL_STYLES = {
  background: 'linear-gradient(135deg, #0ea5e9 0%, #d946ef 100%)',
  backgroundHover: 'linear-gradient(135deg, #0284c7 0%, #c026d3 100%)',
  color: '#ffffff',
  colorHover: '#ffffff',
  border: '2px solid #ffffff',
  boxShadow: '0 2px 6px rgba(14, 165, 233, 0.35)',
  boxShadowHover: '0 4px 12px rgba(14, 165, 233, 0.45)',
};

export default function SidebarEdgeRail({
  open,
  onToggle,
  isRTL = false,
  topOffset = DEFAULT_TOP_OFFSET,
}) {
  const theme = useTheme();
  const { t } = useTranslation();

  const drawerWidth = open ? DRAWER_WIDTH_OPEN : DRAWER_WIDTH_CLOSED;
  const horizontalOffset = drawerWidth - RAIL_WIDTH / 2;
  const tooltipTitle = open
    ? t('nav.collapseSidebar', 'Collapse menu')
    : t('nav.expandSidebar', 'Expand menu');

  let chevron = open ? (
    <ChevronLeftIcon sx={{ fontSize: 18 }} />
  ) : (
    <ChevronRightIcon sx={{ fontSize: 18 }} />
  );
  if (isRTL) {
    chevron = open ? (
      <ChevronRightIcon sx={{ fontSize: 18 }} />
    ) : (
      <ChevronLeftIcon sx={{ fontSize: 18 }} />
    );
  }

  const positionStyles = isRTL
    ? { right: horizontalOffset }
    : { left: horizontalOffset };

  return (
    <Tooltip title={tooltipTitle} placement={isRTL ? 'left' : 'right'}>
      <IconButton
        onClick={onToggle}
        aria-label={tooltipTitle}
        aria-expanded={open}
        sx={{
          position: 'fixed',
          top: `calc(${topOffset}px + (100vh - ${topOffset}px) / 2)`,
          transform: 'translateY(-50%)',
          zIndex: theme.zIndex.drawer + 1,
          width: RAIL_WIDTH,
          height: RAIL_HEIGHT,
          ...positionStyles,
          transition: `${isRTL ? 'right' : 'left'} 0.3s ease, background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease`,
          background: RAIL_STYLES.background,
          border: RAIL_STYLES.border,
          borderRadius: '50%',
          boxShadow: RAIL_STYLES.boxShadow,
          color: RAIL_STYLES.color,
          '&:hover': {
            background: RAIL_STYLES.backgroundHover,
            color: RAIL_STYLES.colorHover,
            boxShadow: RAIL_STYLES.boxShadowHover,
            transform: 'translateY(-50%) scale(1.05)',
          },
          '&:focus-visible': {
            outline: `2px solid ${RAIL_STYLES.colorHover}`,
            outlineOffset: 2,
          },
        }}
      >
        {chevron}
      </IconButton>
    </Tooltip>
  );
}
